//capitals pages - converted to lazy loading
const capitalsIndex = () => import('@/pages/capitals/index.vue')
const capitalsForm = () => import('@/pages/capitals/form.vue')
const capitalsShow = () => import('@/pages/capitals/show.vue')

const routes = [
  // customers routes
  {
    path: 'capitals',
    name: 'capitals',
    component: capitalsIndex
  },
  {
    path: 'capitals/create',
    name: 'capitalsCreate',
    component: capitalsForm
  },
  {
    path: 'capitals/:id/edit',
    name: 'capitalsEdit',
    component: capitalsForm
  },
  {
    path: 'capitals/:id',
    name: 'capitalsShow',
    component: capitalsShow
  }
]

export default routes
